
export const ERROR_INTERNO_SISTEMA = 'Ha ocurrido un error interno del sistema';
export const ERROR_VALIDACION_FORMULARIO = 'Por favor, verifique que todos los campos estén completos y correctamente diligenciados';
